module.exports = __webpack_public_path__ + "static/media/11.393eaa16.png";